
import useAxiosPrivate from "./useAxiosPrivate";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
const useUpdateStepScheme = () => {
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();
  const updateStepScheme = async (param) => {
    
    const response = await Axios.post("update_step_schemes", param);
    const data = await response.data;

    // if (data.code === 200) {
    //   toast.success("Updated SuccessFully");
    // } else {
    //   toast.error("Update Failed");
    // }
  };
  return updateStepScheme;
};

export default useUpdateStepScheme;
